// header-mega-menu.js
// Behavior for mega menu summaries:
// - First activation (click/Enter/Space) opens the details (default behavior)
// - If the details is already open, activation follows the URL stored on the summary's `data-href`
// - Respects modifier keys: Ctrl/Cmd/Shift opens in a new tab/window

(function () {
  if (typeof document === 'undefined') return;

  function openInNewTab(url) {
    try {
      window.open(url, '_blank');
    } catch (e) {
      // fallback to same-window navigation
      window.location.href = url;
    }
  }

  document.querySelectorAll('details.mega-menu').forEach(function (details) {
    var summary = details.querySelector('summary');
    if (!summary) return;

    var href = summary.getAttribute('data-href');

    summary.addEventListener('click', function (event) {
      // If details is open and we have a target href, navigate
      if (details.hasAttribute('open') && href) {
        event.preventDefault();
        // Respect modifier keys (Ctrl/Cmd/Shift) to open in new tab/window
        if (event.ctrlKey || event.metaKey || event.shiftKey) {
          openInNewTab(href);
        } else {
          window.location.href = href;
        }
      }
    });

    summary.addEventListener('keydown', function (event) {
      var key = event.key;
      if (!href) return;

      if ((key === 'Enter' || key === ' ') && !details.hasAttribute('open')) {
        // Open first
        event.preventDefault();
        details.setAttribute('open', '');
      } else if ((key === 'Enter' || key === ' ') && details.hasAttribute('open')) {
        // Navigate if open
        event.preventDefault();
        if (event.ctrlKey || event.metaKey || event.shiftKey) {
          openInNewTab(href);
        } else {
          window.location.href = href;
        }
      }
    });
  });
})();
